export default {
  picks: {
    title: "Mes choix",
    actions: {
      selectLocation: "Choisir un emplacement",
      importPhoto: "Importer une photo",
      takePhoto: "Prendre une photo",
      selectOperatorToContinue: "Choisir un opérateur pour continuer",
      openOn: "Ouvrir sur {{operator}}",
      visit: "Visiter {{operator}}",
    },
    locationGate: {
      title: "Autorisez Linemate à accéder à votre emplacement pour utiliser Mes choix",
      subtitle: "Linemate utilise votre emplacement pour afficher les marchés et offres disponibles dans votre région.",
    },
    empty: {
      title: "Aucun choix pour l'instant",
      subtitle: "Touchez une tendance pour l'ajouter, ou partagez simplement une photo et nous récupérerons les choix pour vous.",
    },
    imageImport: {
      title: "Importer des choix",
      scanningBetslip: "Analyse de votre betslip...",
      analyzingImage: "Analyse de votre image...",
      detectingOdds: "Détection des cotes",
      failed: "Échec de l'importation des choix",
      pleaseTryAgain: "Veuillez réessayer",
      tryAgain: "Réessayer",
    },
    labels: {
      parlay: "Combiné",
      sgp: "SGP",
      straight: "Simple",
      legParlay: "Combiné de {{count}} sélections",
      pricingUnavailable: "Prix non disponible",
      continueToOperator: "Continuer vers votre opérateur",
    },
    sections: {
      availableOrAdjusted: "Tous les props disponibles ou ajustés",
      missingProps: "Props manquants",
      unavailableInRegion: "Non disponible dans votre région",
    },
    warnings: {
      legsNotFound_one: "{{count}} sélection introuvable",
      legsNotFound_other: "{{count}} sélections introuvables",
      adjusted_one: "{{count}} sélection a été ajustée",
      adjusted_other: "{{count}} sélections ont été ajustées",
      and: " et ",
      forOperator: " pour {{operator}}.",
    },
  },
};
